module.exports = __webpack_public_path__ + "static/media/logoWhite@2x.07bb99ee.webp";